import { useQuery } from "@tanstack/react-query";
import { FILTER_OPERATIONS, QueryBuilder } from "features/members";
import { axios } from "lib/axios";

export const getCampaignsPaginated = ({
  churchId,
  page,
  pageSize,
  queries
}) => {
  const queryBuilder = new QueryBuilder();

  queryBuilder.pagination(page, pageSize);

  if (queries.search) {
    queryBuilder.search(queries.search);
  }

  if (queries.startDate && queries.endDate) {
    queryBuilder.filter({
      updated_at: [
        {
          operator: FILTER_OPERATIONS.BETWEEN,
          value: [queries.startDate, queries.endDate]
        }
      ]
    });
  }

  const queryString = queryBuilder.build();

  return axios.get(`/churches/${churchId}/campaigns-paginated${queryString}`);
};

export const useCampaignsPaginated = ({
  churchId,
  page,
  pageSize,
  queries = {},
  config
} = {}) => {
  return useQuery({
    ...config,
    queryKey: [
      "campaigns-paginated",
      churchId,
      page,
      pageSize,
      JSON.stringify(queries)
    ],
    queryFn: () =>
      getCampaignsPaginated({
        churchId,
        page,
        pageSize,
        queries
      })
  });
};
